import { Component, OnInit, Input, Inject, ViewChild } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-addIncome',
  templateUrl: './addIncome.component.html',
  styleUrls: ['./addIncome.component.scss'] 
})

export class AddIncomeComponent implements OnInit {

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  OfficeIDList: any=[];
  myOfficeID: any; 
  selectedCoreName:string="";
  episodeID:number=0;
  coreID:number=0;
  formDialog: FormGroup; 
  incomeID:number=0;
  spinner:boolean=false;
  type:number=0;

  constructor(private dialog: MatDialog,private dialog1: MatDialog,private datePipe: DatePipe, public dialogRef: MatDialogRef<AddIncomeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private settingsService: SettingService, private statusConst: StatusConstant,
    private coreService: CoreService, private toastr: ToastrService ) {  
     
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    if(encryptedtoken!=null){
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
      this.currentUser = jwt_decode(token); 
      var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
    } 
    
  }  
  
  ngOnInit(): void {  
   this.selectedCoreName=this.data.selectedCoreName;
   this.episodeID = this.data.episodeID;
   this.coreID = this.data.coreID;
   this.incomeID = this.data.incomeID;
   this.type = this.data.type;   
   let addincome = {};
   this.formDialog = new FormGroup(addincome);
   this.formDialog.addControl('title', this.formBuilder.control('', Validators.required));
   this.formDialog.addControl('amount', this.formBuilder.control('', Validators.required));
   this.formDialog.addControl('frequency', this.formBuilder.control('', Validators.required));
   this.formDialog.addControl('description', this.formBuilder.control(''));
   this.formDialog.addControl('verificationStatus', this.formBuilder.control('', Validators.required));
   // 0- Coming from Resident
   if(this.type==0){
    this.formDialog.addControl('type', this.formBuilder.control('0', Validators.required));
   }
   // 1- Coming from spouse
   if(this.type>0){
    this.formDialog.addControl('type', this.formBuilder.control('1', Validators.required));
   }
   
   if(this.incomeID>0){
    this.formDialog.get('title')?.setValue(this.data.incomeData.title);
    this.formDialog.get('amount')?.setValue(this.data.incomeData.amount);
    this.formDialog.get('frequency')?.setValue((this.data.incomeData.frequency).toString());
    this.formDialog.get('description')?.setValue(this.data.incomeData.note);
    this.formDialog.get('verificationStatus')?.setValue((this.data.incomeData.verificationStatus).toString());
   }
  }
      
  

   numberOnly(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;

    // Allow: Backspace, Tab, Delete, Left, Right arrows
    if ([8, 9, 46, 37, 39].includes(charCode)) {
      return true;
    }

    // Allow numbers (0-9)
    if (charCode >= 48 && charCode <= 57) {
      return true;
    }

    // Allow decimal point (.)
    if (charCode === 46) {
      // Prevent more than one decimal point
      const inputValue = (event.target as HTMLInputElement).value;
      if (inputValue.includes('.')) {
        return false;
      }
      return true;
    }

    return false;
  }

  addIncomeForPDPMCore(data:any) {
     var ReqModel = {
      episodeID:this.episodeID,
      coreID:this.coreID,
      title: data.title,
      description: data.description,
      amount: Number(data.amount),
      frequency: Number(data.frequency),         
      verificationStatus:Number(data.verificationStatus),
      incomeID: this.incomeID,
      incomeBy:Number(data.type),//Number(this.type),
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      userId: this.currentUser.UID,
      officeID:this.myOfficeID
    }   
     this.spinner=true;
     this.formDialog.markAsPristine();
    //return;
    this.coreService.addIncomeForPDPMCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinner=false;
        if (this.responseHolder.data == true) {  
          this.formDialog.reset();       
          this.dialogRef.close('Added');
          if(this.incomeID==0){
            this.toastr.success('Income added successfully.', '', {
            timeOut: 2000,
           });  
          }
           if(this.incomeID>0){
            this.toastr.success('Income update successfully.', '', {
            timeOut: 2000,
           });  
          }
             
        }else{
          this.spinner=false;
          this.toastr.warning('Error occurred.', '', {
            timeOut: 2000,
          });         
        }
      }else{
        this.spinner=false;
      }
    });
  }

  closeDialog(){
    this.formDialog.reset();
     this.dialogRef.close();
  //  this.dialog.closeAll();
  }

    
}
